// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.

/** Device type string for mobile devices, as returned by useRequestData()/useDeviceType(). */
export const DEVICE_TYPE_MOBILE = 'MOBILE';

/** id of the main drawer's role="dialog" element. Must match HamburgerButton's aria-controls. */
export const MAIN_DIALOG_ID = 'ws-nav-drawer-main-dialog';

/** id of the drilldown panel's role="dialog" element. Must match SubMenuTrigger's aria-controls. */
export const DRILLDOWN_DIALOG_ID = 'ws-nav-drawer-drilldown-dialog';

/** Shared fragment marker class every fragment-scoped rule in _fragment.scss keys off. */
export const SHARED_FRAGMENT_MARKER = 'ws-nav-drawer__fragment';
